export enum ApiOperations {
  CREATE = "create",
  UPDATE = "update",
  DELETE = "delete",
}
